import { useState, useEffect } from "react";
import './style.css';
import PaymentPopup from "./PaymentPopup";
import { getDetails } from "../../services/liferay/paymentRefund";
import { Loader } from "../../common/Loader";
import { ServiceTranslation } from "../../utils/constants";
import { otherServicesDashboardURL } from "../../utils/util";
import { fetchTranslationData } from "../../services/translation/translation";

const PaymentRefund = () => {
  const [formData, setFormData] = useState({
    servCode: "",
    sptrn: ""
  });
  const [currentRecords, setCurrentRecords] = useState({});
  const [popup, setPopup] = useState(false);
  const [handleAlert, setHandleAlert] = useState(false);
  const [noDetailsFound, setNoDetailsFound] = useState(false);
  const [alert, setAlert] = useState(false);
  const [loading, setLoading] = useState(false);
  const [refundFailed, setRefundFailed] = useState(false);
  const [translationMap, setTranslationMap] = useState(null);

  useEffect(() => {
    fetchTranslationData(ServiceTranslation.PaymentRefund).then((result) => {
      setTranslationMap(result);
    });
  }, []);

  const fetchData = async (e) => {
    if (formData.servCode === "" || formData.sptrn === "") {
      setAlert(true);
      return;
    }
    try {
      setRefundFailed(false);
      setHandleAlert(false);
      setLoading(true);
      setAlert(false);
      setNoDetailsFound(false);
      const response = await getDetails(formData.sptrn, formData.servCode);
      if (response && response.data)
      {
        setCurrentRecords(response?.data);
      } else
      {
        setCurrentRecords({});
        setNoDetailsFound(true);
      }
    }
    catch {
      setCurrentRecords({});
      setNoDetailsFound(true);
    } finally
    {
      setLoading(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const form = e.target;
    if (!form.checkValidity()) {
      form.reportValidity(); // Show browser validation messages
      return;
    }
  };

  const handleEnterKey = async (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      const form = document.getElementById("reconForm");
      if (form.checkValidity()) {
        await fetchData();
      } else {
        form.reportValidity();
      }
    }
  };

  const handleChange = (e) =>{
    const {name,value} = e.target;
    let sanitizedValue = value;
    // applying sanitization for the sptrn value
    if ( name === "sptrn") {
        sanitizedValue = value.replace(/[^A-Za-z0-9\u0600-\u06FF\s]/g, "");
        }
    setFormData((prevData)=>(
        {
            ...prevData,
            [name]: sanitizedValue
        }));
  };

  if (loading)
  {
    return (
      <Loader />);

  }

  return (
    <>
            <div className="refund-container">
                <div className="container">
                    <div className="reconciliationFormGroup">
                        <div className="title-bar">
                            <div className="report-title">{translationMap?.page_title || "Dubai Health Payment Gateway"}</div>
                            <button
                className="dashboard-btn"
                onClick={() => window.location.href = otherServicesDashboardURL()}>

                                {translationMap?.go_to_dashboard || "Go to Dashboard"}
                            </button>
                        </div>


                        {handleAlert &&
            <div className="AlertInnerBox GreenAlertInnerBox alert alert-dismissible fade show">
                                <button
                type="button"
                className="close"
                data-dismiss="alert"
                onClick={() => setHandleAlert(false)}>
                
                                    &times;
                                </button>
                                <div className="Icon_box">
                                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                                    <a>
                          <span className="material-symbols-outlined">
                            check_circle
                          </span>
                                    </a>
                                </div>
                                <div className="alert_text">
                                    <h6>
                                        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                                        <a>{translationMap?.refund_success_message || "Your request has been executed successfully"}</a>
                                    </h6>
                                </div>
                            </div>
            }
                        {refundFailed &&
            <>
                                <div className="AlertInnerBox AlertInnerBox2 YellowAlertInnerBox alert alert-dismissible fade show">
                                    <button
                  type="button"
                  className="close"
                  data-dismiss="alert"
                  onClick={() => setRefundFailed(false)}>
                  
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M17 7L7 17M7 7L17 17" stroke="#002F70" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round" />
                                        </svg>
                                    </button>
                                    <div className="Icon_box">
                                        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                                        <a>
                                            <span className="material-symbols-outlined">warning</span>
                                        </a>
                                    </div>
                                    <div className="alert_text">
                                        <h6>
                                            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                                            <a>{translationMap?.refund_error_message || "Error while processing the refund request."}</a>
                                        </h6>
                                    </div>
                                </div>
                            </>
            }
                        {alert &&
            <div className="AlertInnerBox AlertInnerBox2 YellowAlertInnerBox alert alert-dismissible fade show">
                                <button
                type="button"
                className="close"
                data-dismiss="alert"
                onClick={() => setAlert(false)}>
                
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M17 7L7 17M7 7L17 17" stroke="#002F70" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round" />
                                    </svg>
                                </button>
                                <div className="Icon_box">
                                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                                    <a>
                                        <span className="material-symbols-outlined">warning</span>
                                    </a>
                                </div>
                                <div className="alert_text">
                                    <h6>
                                        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                                        <a>{translationMap?.fill_both_fields_error || "Please fill in both fields."}</a>
                                    </h6>
                                </div>
                            </div>
            }
                        <div className="reconciliationForm">
                            <form id="reconForm" onSubmit={handleSubmit} onKeyDown={handleEnterKey}>
                                <div className="form-section">
                                    <div className="formGroup">
                                        <label><span className="required">*</span>{translationMap?.service_label || "Service"}</label>
                                        <select onChange={handleChange} name="servCode" value={formData.servCode} required>
                                            <option value="">{translationMap?.select_placeholder || "---Select---"}</option>
                                            <option value="SLA">{translationMap?.sick_leave_application || "Sick Leave Application"}</option>
                                            <option value="MR">{translationMap?.medical_report || "Medical Report"}</option>
                                            <option value="NPS">{translationMap?.renew_health_card || "Renew Health Card"}</option>
                                            <option value="PHC">{translationMap?.premarital_screening || "Premarital Screening"}</option>
                                        </select>
                                    </div>

                                    <div className="formGroup" onChange={handleChange}>
                                        <label><span className="required">*</span>{translationMap?.sptrn_label || "SPTRN"}</label>
                                        <input type="text" name="sptrn" value={formData.sptrn} required />
                                    </div>
                                </div>

                                <div className="buttons">
                                    <button type="button" onClick={fetchData}>{translationMap?.grid_button || "Grid"}</button>
                                </div>
                            </form>
                        </div>
                    </div>
                    {currentRecords && Object.keys(currentRecords).length > 0 &&
          <div id="tableGrid" className="table-container">
                            <table>
                                <thead>
                                <tr>
                                    <th>{translationMap?.table_sptrn || "SPTRN"}</th>
                                    <th>{translationMap?.table_degtrn || "DEGTRN"}</th>
                                    <th>{translationMap?.table_transaction_date || "Transaction Date"}</th>
                                    <th>{translationMap?.table_payment_status || "Payment Status"}</th>
                                    <th>{translationMap?.table_amount || "Amount"}</th>
                                    <th>{translationMap?.table_payment_method || "Payment Method"}</th>
                                    {currentRecords.PaymentStatus === "SUCCESS" &&
                  <th></th>
                  }
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td>{currentRecords.SPTRN}</td>
                                    <td>{currentRecords.ReturnDEGTRN}</td>
                                    <td>{currentRecords.PaymentCreatedon}</td>
                                    <td>{currentRecords.PaymentStatus}</td>
                                    <td>{currentRecords?.Amount}</td>
                                    <td>{currentRecords.ReturnPymtMethod}</td>
                                    {currentRecords.PaymentStatus === "SUCCESS" &&
                  <td>
                                            <button className="refund-btn" onClick={() => setPopup(true)}>{translationMap?.refund_button || "Refund"}</button>
                                        </td>
                  }
                                </tr>


                                </tbody>
                            </table>
                        </div>

          }

                    {noDetailsFound &&
          <div className="noDetail">{translationMap?.no_details_found || "No Details found"}</div>
          }

                </div>
                {popup &&
        <PaymentPopup setPopup={setPopup} formData={formData} setHandleAlert={setHandleAlert} setCurrentRecords={setCurrentRecords} setRefundFailed={setRefundFailed} translationMap={translationMap} />
        }
            </div>

        </>);

};

export default PaymentRefund;